import { Helmet } from 'react-helmet-async';

import Container from '@mui/material/Container';
import { FullLayoutWrap } from '../components/Base';
import { Outlet } from 'react-router-dom';
 
const FullLayout = () => (
    <>
        <Helmet>
            <meta name="viewport" content="width=device-width, initial-scale=1" />
        </Helmet>
        <FullLayoutWrap>
            <Container maxWidth='lg'>
                <Outlet />
            </Container>
        </FullLayoutWrap>
    </>
);

export default FullLayout;
